import { existsSync } from "fs"
import { join } from "path"

export function validateProjectName(value: string): boolean | string {
  if (!value || value.trim().length === 0) {
    return "Project name is required"
  }

  const validName = /^(?:@[a-z0-9-*~][a-z0-9-*._~]*\/)?[a-z0-9-~][a-z0-9-._~]*$/
  if (!validName.test(value)) {
    return "Project name must be a valid npm package name (lowercase, no spaces)"
  }

  if (existsSync(join(process.cwd(), value))) {
    return `Directory "${value}" already exists`
  }

  const reserved = [
    "node_modules",
    "favicon.ico",
    "package.json",
    "tsconfig.json",
    ".git",
    ".gitignore",
  ]

  if (reserved.includes(value.toLowerCase())) {
    return `"${value}" is a reserved name`
  }

  return true
}

export function validatePackageManager(value: string): boolean | string {
  const valid = ["npm", "pnpm", "yarn", "bun"]
  if (!valid.includes(value)) {
    return `Invalid package manager. Choose from: ${valid.join(", ")}`
  }
  return true
}

export function validateFramework(value: string): boolean | string {
  const valid = ["react", "vue", "svelte", "astro", "vanilla"]
  if (!valid.includes(value)) {
    return `Invalid framework. Choose from: ${valid.join(", ")}`
  }
  return true
}
